import { Form, InputNumber, Radio, Typography } from "antd";
import { useEffect } from "react";
import styled from "styled-components";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, SubmitButton } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

const Opcoes = styled(Radio.Group)`
  display: grid;
  gap: 14px;
  width: 100%;
  .ant-radio-wrapper {
    align-items: flex-start;
    border: 1px solid #d7e2e6;
    border-radius: 14px;
    margin: 0;
    padding: 18px 20px;
  }
  .ant-radio-wrapper-checked { background: #eef8f8; border-color: #0b6673; }
`;

export function EtapaOutrosDetalhesVenda({ fluxo, submitting, onConcluir }: Props) {
  const [form] = Form.useForm();
  const salvo = (fluxo.dadosPreenchidos?.venda ??
    fluxo.dadosPreenchidos?.outrosDetalhesVenda) as Record<string, unknown> | undefined;

  useEffect(() => { form.setFieldsValue(salvo); }, [form, salvo]);

  return (
    <OnboardingFrame
      fluxo={fluxo}
      title="Outros detalhes da venda"
      description="Essas informações ajudam os interessados a entender melhor as condições da sua cota."
    >
      <Form layout="vertical" form={form} initialValues={salvo} onFinish={onConcluir}>
        <Form.Item
          name="aceitaTroca"
          label="Gostaria de receber oportunidades de troca pela sua cota?"
          rules={[{ required: true, message: "Informe se deseja receber oportunidades de troca." }]}
        >
          <Opcoes>
            <Radio value><Typography.Text strong>Sim</Typography.Text></Radio>
            <Radio value={false}><Typography.Text strong>Não</Typography.Text></Radio>
          </Opcoes>
        </Form.Item>

        <Form.Item
          name="valorCondominio"
          label="Qual é o valor atual do condomínio da sua cota?"
          rules={[{ required: true, message: "Informe o valor do condomínio." }]}
        >
          <InputNumber prefix="R$" min={0} style={{ width: "100%" }} decimalSeparator="," placeholder="0,00" />
        </Form.Item>

        <SubmitButton label="Continuar" loading={submitting} />
      </Form>
    </OnboardingFrame>
  );
}
